import React from "react";
import TourCard from "../../shared/DestCard1";
import tourData from "../../assets/data/dest";
import { Col, Button} from "reactstrap";
import { Link } from "react-router-dom";

const FeaturedTourList1 = () => {
  const displayedTours = tourData.slice(0, 4);

  return (
    <>
      {displayedTours.map((tour) => (
        <Col lg="3" md="6" sm="6" className="mb-4" key={tour.id}>
          <TourCard tour={tour} />
        </Col>
      ))}

      <Link to="/destinations">
        <Button style={{ float: "right" }} className="primary__btn">See more...</Button>
      </Link>
    </>
  );
};

export default FeaturedTourList1;
